import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { ownerDocument } = button
    const direction = ownerDocument.dir
    ownerDocument.dir = direction === 'ltr' ? 'rtl' : 'ltr'
  }
})

export default button => {
  onClick.listen(button)
}
